<template>
  <div class="update-results">
    <h2>LANÇAR RESULTADOS</h2>
    <form @submit.prevent="submitResults">
      <div class="form-group">
        <label for="stage">Etapa:</label>
        <select v-model="selectedStageId" @change="fetchGames" id="stage" required>
          <option v-for="stage in stages" :key="stage.id" :value="stage.id">
            {{ stage.name }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label for="adversary">Adversário:</label>
        <select v-model="selectedGameId" @change="updateSelectedGame" id="adversary" required>
          <option v-for="game in games" :key="game.id" :value="game.id">
            {{ getAdversario(game) }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label for="status">Status:</label>
        <select v-model="gameStatus" id="status" required>
          <option value="Não Realizado">Não Realizado</option>
          <option value="Realizado">Realizado</option>
          <option value="WO">WO</option>
        </select>
      </div>

      <div class="form-group">
        <label>Placar:</label>
        <div class="score-inputs">
          <div class="score-header">
            <span>{{ Jogador }}</span>
            <span>{{ Adversario }}</span>
          </div>
          <div class="score-row" v-for="(set, index) in score" :key="index">
            <span class="set-label">Set {{ index + 1 }}:</span>
            <input v-model.number="set.jogador" type="number" :min="0" :max="getMax(index)" @blur="validarLimite(set, 'jogador', index)" class="score-input" @focus="limparCampo(set, 'jogador')" required>
            <span>X</span>
            <input v-model.number="set.adversario" type="number" :min="0" :max="getMax(index)" @blur="validarLimite(set, 'adversario', index)" class="score-input" @focus="limparCampo(set, 'adversario')" required>
          </div>
        </div>
      </div>

      <button type="submit" class="save-button" v-show="this.showBtnSalvar">Salvar</button>
      <div class="error-message" v-if="errorMessage">{{ errorMessage }}</div>
    </form>
  </div>
</template>

<script>
import gameService from '@/services/gameService';
import stageService from '@/services/stageService';
import userService from '../services/userService';
import groupService from "@/services/groupService";
import playerService from "@/services/playerService";

export default {
  name: 'UpdateResults',
  data() {
    return {
      stages: [],
      players: [],
      games: [],
      selectedStageId: null,
      selectedGroupId: null,
      selectedGameId: null,
      selectedPlayerId: null,
      gameStatus: 'Não Realizado',
      loggedInUser: '',
      score: [
        {jogador: 0, adversario: 0},
        {jogador: 0, adversario: 0},
        {jogador: 0, adversario: 0},
      ],
      errorMessage: '',
      showBtnSalvar: true,
    };
  },
  computed: {
    Jogador() {
      const selectedPlayer = this.players.find(player => player.userId === this.loggedInUser);
      return selectedPlayer ? selectedPlayer.User.fullName : 'Jogador';
    },
    Adversario() {
      const selectedGame = this.games.find(game => game.id === this.selectedGameId);
      if (!selectedGame) {
        return 'Adversário';
      }
      if (selectedGame.player1.id === this.selectedPlayerId) {
        return selectedGame.player2.User.fullName;
      } else {
        return selectedGame.player1.User.fullName;
      }
    }
  },
  watch: {
    gameStatus(newStatus) {
      this.errorMessage = '';
      if (newStatus === 'WO') {
        this.setWOScore();
      }
    },
    selectedGameId(newGameId) {
      if (newGameId) {
        this.fetchGames();
        this.defaultValues();
      }
    }
  },
  created() {
    this.fetchStages();
    this.getUserId();
  },
  methods: {
    async getUserId(){
      try{
        const response = await userService.getUserId();
        this.loggedInUser = response.data;
        await this.selectPlayerId();
        await this.getUserGroupId();
      } catch (error){
        console.log('Erro ao buscar usuário', error);
      }
    },
    async fetchStages(){
      try{
        const response = await stageService.getAllStages();
        this.stages = response.data;
        if (this.stages.length > 0){
          this.selectedStageId = this.stages[this.stages.length - 1].id;
        }
      } catch (error){
        console.error('Erro ao buscar etapas', error);
      }
    },
    async selectPlayerId(){
      try{
        const response = await playerService.getPlayerByUserId(this.loggedInUser);
        this.selectedPlayerId = response.data.id;
      } catch (error){
        console.error('Erro ao buscar jogador logado', error);
      }
    },
    async getUserGroupId(){
      try{
        this.selectedGroupId = await groupService.getUserGroupId(this.loggedInUser);
        await this.fetchPlayers();
      } catch(error){
        console.error('Erro ao buscar grupo do usuário', error);
      }
    },
    async fetchPlayers(){
      try{
        const response = await groupService.getPlayersByGroup(this.selectedGroupId);
        this.players = response.data;
        await this.fetchGames();
      } catch (error) {
        console.error('Erro ao buscar jogadores do grupo', error);
      }
    },
    async fetchGames(){
      try{
        const response = await gameService.getPlayerGamesByPlayerId(this.selectedStageId, this.selectedPlayerId);
        this.games = response.data;
        this.updateSelectedGame();
      } catch(error){
        console.error('Erro ao carregar jogos do grupo', error)
      }
    },
    async submitResults(){
      const game = this.games.find(game => game.id === this.selectedGameId);

      if (!game) {
        alert('Jogo não encontrado');
      }

      const updatedGame = {
        status: this.gameStatus,
        set1Player1: game.player1.id === this.selectedPlayerId ? this.score[0].jogador : this.score[0].adversario,
        set1Player2: game.player2.id === this.selectedPlayerId ? this.score[0].jogador : this.score[0].adversario,
        set2Player1: game.player1.id === this.selectedPlayerId ? this.score[1].jogador : this.score[1].adversario,
        set2Player2: game.player2.id === this.selectedPlayerId ? this.score[1].jogador : this.score[1].adversario,
        set3Player1: game.player1.id === this.selectedPlayerId ? this.score[2].jogador : this.score[2].adversario,
        set3Player2: game.player2.id === this.selectedPlayerId ? this.score[2].jogador : this.score[2].adversario,
      };

      const player1 = {
        stageId: this.selectedStageId,
        playerId: game.player1.id
      };

      const player2 = {
        stageId: this.selectedStageId,
        playerId: game.player2.id
      };

      try {
        await gameService.updateGame(this.selectedGameId, updatedGame);
        await playerService.updateAverage(player1);
        await playerService.updateAverage(player2);
        alert('Resultados salvos com sucesso');
        await this.fetchGames();
      } catch (error) {
        console.error("Erro ao salvar resultados:", error);
      }

    },
    updateSelectedGame(){
      const game = this.games.find(game => game.id === this.selectedGameId);
      if (game){
        this.gameStatus = game.status;
        const isJogador = game.player1.id === this.selectedPlayerId;
        if (isJogador){
          this.score = [
            {jogador: game.set1Player1, adversario: game.set1Player2},
            {jogador: game.set2Player1, adversario: game.set2Player2},
            {jogador: game.set3Player1, adversario: game.set3Player2},
          ];
        } else {
          this.score = [
            {jogador: game.set1Player2, adversario: game.set1Player1},
            {jogador: game.set2Player2, adversario: game.set2Player1},
            {jogador: game.set3Player2, adversario: game.set3Player1},
          ];
        }
      }
    },
    getAdversario(game){
      const eu = this.selectedPlayerId;
      if (eu === game.player1.id){
        return game.player2.User.fullName;
      } else if (eu === game.player2.id){
        return game.player1.User.fullName;
      } else{
        console.log('Jogador não encontrado');
        return false
      }
    },
    defaultValues(){
      const game = this.games.find(game => game.id === this.selectedGameId);
      if (game) {
        const isJogador = game.player1.id === this.selectedPlayerId;
        if (isJogador) {
          this.score = [
            {jogador: 0, adversario: 0},
            {jogador: 0, adversario: 0},
            {jogador: 0, adversario: 0},
          ];
          this.gameStatus = 'Não realizado';
        } else {
          this.score = [
            {jogador: 0, adversario: 0},
            {jogador: 0, adversario: 0},
            {jogador: 0, adversario: 0},
          ];
          this.gameStatus = 'Não realizado';
        }
      }
    },
    setWOScore() {
      const game = this.games.find(game => game.id === this.selectedGameId);
      if (game) {
        const isJogador = game.player1.id === this.selectedPlayerId;
        if (isJogador) {
          this.score = [
            {jogador: 6, adversario: 0},
            {jogador: 6, adversario: 0},
            {jogador: 0, adversario: 0},
          ];
        } else {
          this.score = [
            {jogador: 6, adversario: 0},
            {jogador: 6, adversario: 0},
            {jogador: 0, adversario: 0},
          ];
        }
      }
    },
    getMax(index){
      if (index === 0 || index === 1){
        return 7;
      }
      if (index === 2){
        return 30;
      }

      return 0;
    },
    limparCampo(set, campo){
      if (set[campo] === 0 || set[campo] === null){
        set[campo] = '';
      }
    },
    validarLimite(set, campo, index){
      const max = this.getMax(index);

      if (set[campo] === '' || set[campo] === null || set[campo] === undefined) {
        set[campo] = 0;
        return;
      }

      const valor = Number(set[campo]);

      if (Number.isNaN(valor)){
        set[campo] = 0;
        return;
      }

      if (valor > max){
        set[campo] = max;
        return;
      }

      if (valor < 0) {
        set[campo] = 0;
        return;
      }

      set[campo] = valor;
    }
  }
}
</script>

<style scoped>
.update-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  background-color: #FFF;
  color: black;
  border-radius: 10px;
  max-width: 600px;
  width: 80%;
  margin: auto;
  box-sizing: border-box;
}

.update-results h2 {
  margin-bottom: 1.5rem;
  color: black;
}

.form-group {
  margin-bottom: 1rem;
  width: 100%;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: black;
}

.form-group select,
.form-group input {
  width: 100%;
  padding: 0.5rem;
  border-radius: 4px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  background-color: white;
  color: black;
}

.score-inputs {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  padding: 1rem;
  border-radius: 10px;
  color: black;
  margin-bottom: 1rem;
  width: 100%;
}

.score-header {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 0.5rem;
  font-weight: bold;
}

.score-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.5rem;
  width: 100%;
  gap: 8px;
}

.score-row .set-label {
  width: 20%;
  text-align: right;
  margin-right: 0.5rem;
  color: black;
}

.score-row input {
  width: 20%;
  padding: 0.5rem;
  border-radius: 4px;
  border: 1px solid #ccc;
  box-sizing: border-box;
}

.score-row span {
  text-align: center;
  color: black;
  width: 10%;
  margin: 0.25rem 0 ;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"]{
  -moz-appearance: textfield;
  appearance: textfield;
}

.save-button {
  padding: 0.75rem 1.5rem;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
}

.save-button:hover {
  background-color: #218838;
}

.error-message {
  color: red;
  margin-top: 1rem;
  text-align: center;
}

@media (max-width: 768px) {
  .form-group {
    width: 90%;
  }

  .score-header,
  .score-row {
    flex-direction: row;
    align-items: center;
  }

  .score-row .set-label,
  .score-input,
  .score-row span {
    width: 100%;
    text-align: center;
    margin: 0.25rem 0;
  }
}

@media (max-width: 425px) {
  .form-group {
    width: 100%;
  }

  .score-header,
  .score-row {
    flex-direction: row;
    align-items: center;
  }

  .score-row .set-label,
  .score-input,
  .score-row span {
    width: 100%;
    text-align: center;
    margin: 0.25rem 0;
  }
}
</style>
